module.exports = __webpack_public_path__ + "images/cqffc.659c.png";